export const setItem = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value)
  } catch (error) {
    console.error(`Failed to set raw item "${key}" in localStorage`, error)
  }
}

export const getItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key)
  } catch (error) {
    console.error(`Failed to get raw item "${key}" from localStorage`, error)
    return null
  }
}

export const setData = <T>(key: string, value: T): void => {
  try {
    const serialized = JSON.stringify(value)
    localStorage.setItem(key, serialized)
  } catch (error) {
    console.error(`Failed to set item "${key}" in localStorage`, error)
  }
}

export const getData = <T>(key: string): T | null => {
  try {
    const item = localStorage.getItem(key)
    if (!item) return null
    return JSON.parse(item) as T
  } catch (error) {
    console.error(`Failed to parse item "${key}" from localStorage`, error)
    return null
  }
}

export const remove = (key: string): void => {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.error(`Failed to remove item "${key}" from localStorage`, error)
  }
}

export const clear = (): void => {
  try {
    localStorage.clear()
  } catch (error) {
    console.error(`Failed to clear localStorage`, error)
  }
}

export const exists = (key: string): boolean => {
  return localStorage.getItem(key) !== null
}
